<template>
    <div>
        <p :class="pClass">
            Showing
            <span>{{ startRange }}</span>
            to
            <span>{{ endRange }}</span>
            of
            <span>{{ totalResults }}</span>
            results
        </p>
    </div>
</template>

<script>
export default {
    props: {
        pClass: {
            type: String,
            default: 'text-slate-600 text-sm font-medium leading-tight',
        },
        startRange: {
            type: Number,
            required: true,
        },
        endRange: {
            type: Number,
            required: true,
        },
        totalResults: {
            type: Number,
            required: true,
        },
    },
};
</script>
